import { runInAction } from "mobx";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCoreLoginStore from "../../stores/core/core-login-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import {
  LOGIN_BUTTON_DISABLED_SHADOW,
  LOGIN_BUTTON_FONT_SIZE,
  LOGIN_BUTTON_HEIGHT_CSS,
  LOGIN_BUTTON_HOVER_SHADOW,
  LOGIN_BUTTON_PRESS_OFFSET,
  LOGIN_BUTTON_RADIUS_CSS,
  LOGIN_BUTTON_SHADOW,
  LOGIN_FIELD_FOCUS_SHADOW,
  LOGIN_FULL_WIDTH_CSS,
  LOGIN_INPUT_MIN_FONT_PX,
  LOGIN_NO_MINIMUM_CSS,
  LOGIN_TRANSITION
} from "./login-constants";
import { getFlooredFontSize } from "./login-layout";

const SignInButton = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, getFontSize } = theme;
  const store = getCoreLoginStore();
  const disabledButton = store.isSignInDisabled.get();
  const isLoading = store.signInLoading.get();
  const isButtonLocked = getCoreUIStore().buttonLocked.get();
  const isEnabled = isButtonLocked ? false : !disabledButton;
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const backgroundColor = !isEnabled
    ? colors.all.davysGrey
    : colors.all.bondiBlue;

  const boxShadow = (() => {
    switch (true) {
      case !isEnabled:
        return LOGIN_BUTTON_DISABLED_SHADOW;
      case isFocused:
        return LOGIN_FIELD_FOCUS_SHADOW;
      case isHovered:
        return LOGIN_BUTTON_HOVER_SHADOW;
      default:
        return LOGIN_BUTTON_SHADOW;
    }
  })();

  const translateY = isEnabled && isPressed ? LOGIN_BUTTON_PRESS_OFFSET : 0;

  return (
    <button
      disabled={!isEnabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onClick={() => {
        runInAction(() => getCoreUIStore().buttonLocked.set(true));
        getCoreLoginStore().signIn();
        navigate({ pathname: "/" });
        runInAction(() => getCoreUIStore().buttonLocked.set(false));
      }}
      style={{
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: LOGIN_FULL_WIDTH_CSS,
        minWidth: LOGIN_NO_MINIMUM_CSS,
        height: LOGIN_BUTTON_HEIGHT_CSS,
        minHeight: LOGIN_NO_MINIMUM_CSS,
        border: 0,
        borderRadius: LOGIN_BUTTON_RADIUS_CSS,
        backgroundColor,
        boxShadow,
        transform: `translateY(${translateY}px)`,
        transition: LOGIN_TRANSITION,
        cursor: isEnabled ? "pointer" : "default"
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={LOGIN_BUTTON_FONT_SIZE}
        text={isLoading ? i18n.get("SIGNING_IN") : i18n.get("SIGN_IN")}
        isSpan={false}
        color={colors.all.white}
        style={{
          margin: 0,
          fontSize: getFlooredFontSize(
            getFontSize(LOGIN_BUTTON_FONT_SIZE),
            LOGIN_INPUT_MIN_FONT_PX
          )
        }}
      />
    </button>
  );
});
export default SignInButton;
